export function saveInputValueIntoState(event, index, state, setState) {
  const value = event.target.value;
  let newOtpValue = [...state];
  newOtpValue[index] = value.substring(0, 1); // consider the first number typed
  setState(newOtpValue);
}

export function convertInputGroupValuesToString(values) {
  const stringValue = String(values).replace(/,/g, "");
  return stringValue;
}
